import { render, staticRenderFns } from "./wallboard-summary-report.vue?vue&type=template&id=7f553224"
import script from "./wallboard-summary-report.vue?vue&type=script&lang=js"
export * from "./wallboard-summary-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports